export interface ContributionConfig {
    evening: number;
    saturday: number;
    sunday: number;
}
export interface CostCentreContribution extends ContributionConfig {
    employeeId: string;
    costCentre: string;
    duration?: {
        startDate: string;
        endDate: string;
    };
}
export type CostDistribution = {
    costCentre: string;
    costCentrePercent: number;
    isPrimary?: boolean;
};
export type ContractRange = {
    type: string;
    range: {
        max: number;
        min: number | null; // Min = null means min = max.
    };
    description: string;
};
export enum EmploymentStatus { ACTIVE = 'active', DEACTIVATED = 'deactivated' }
export enum EmploymentType { COWORKER = 'COWORKER', CONTINGENT_WORKER = 'CONTINGENT_WORKER' }
export enum CoworkerAvailability {
    ABSENCE = 'A',
    HOLIDAY = 'H',
    CONTRACT_START_OR_END = 'contract_start_or_end',
    HOURS = 'hours'
}
type Flags = {
    subType: string;
    value: string | null;
};
export interface Coworker {
    contractType: string;
    contractEndDate: string | null;
    contractStartDate: string | null;
    contributions: Array<CostCentreContribution>;
    createdBy: string;
    createdOn: string;
    costCentre: string;
    departmentCode: string;
    departmentName: string;
    employeeId: string;
    personalAreaName: string;
    division: string;
    divisionName: string;
    email: string;
    status: EmploymentStatus;
    employmentType: EmploymentType;
    hoursPerWeek: number;
    jobTitle: string;
    firstName: string;
    lastName: string;
    middleName: string | null;
    personId: string;
    contractRange: ContractRange | null | undefined;
    isContractRangeSupport: boolean;
    orgId: number;
    jobCode: string;
    validity: string[];
    orgUnitId: number;
    incomplete: boolean;
    emailType: string;
    networkId: string;
    nameType: string;
    managerPersonId: string;
    cost: Array<{
        id: string;
        percentage: number;
        isPrimary: boolean;
    }>,
    flags: Array<Flags>;
    // Manually added attributes
    costDistributions: Array<CostDistribution>;
    isDummy?: boolean;
    legalFullName: string;
    isModulated: boolean;
    futureData?: Array<Partial<Coworker>>;
}
